import React, { useState, useEffect, useMemo } from "react";
import { TextField, Select, MenuItem } from "@material-ui/core";
import {
  getPickerData,
} from "../../../pages/Landing/components/CountryPicker";
import API from "../../../network";
import PublicIcon from "@material-ui/icons/Public";
import "./index.css";

const SearchBox = ({
  searchValue,
  handleSearch,
  handleClear,
  defaultCountry,
  onChangeCountry,
  countryList,
  countryTenantList,
  updateAlertShow,
  signIn,
  setIsPrivatePopupClosed,
  setCountryHasDefaultCommBlocked,
  setIsGlobalSearch,
}) => {
  const [selectedCountry, setSelectedCountry] = useState({});
  const countryData = getPickerData();
  const [countryWithoutCommunities, setCountryWithoutCommunities] =
    useState(null);
  const [countryDetails, setCountryDetails] = useState(null);

  // NEW: Global Search option
  const GLOBAL_SEARCH = {
    country_name: "Search all Countries",
    country_code: "GLOBAL",
  };

  useEffect(() => {
    setSelectedCountry(defaultCountry);
  }, [defaultCountry]);

  useEffect(() => {
    const fetchCountryData = async () => {
      try {
        // const resp = await API.fetchCountryWithCommunity();
        const resp = await API.fetchCountryList();
        setCountryDetails(resp?.data?.countryList);
        setCountryWithoutCommunities(resp?.data?.countryTenantList);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchCountryData();
  }, []);

  const onCountryChange = (e) => {
    updateAlertShow(false);
    setIsPrivatePopupClosed(true);

    const country = e.target.value;

    if (!country) return;

    setSelectedCountry(country);

    // NEW: Global Search selected
    if (country?.country_code === "GLOBAL") {
      setIsGlobalSearch(true);
      return;
    }

    // Normal country selected
    setIsGlobalSearch(false);
    onChangeCountry(country);
  };

  const getCountryFlag = (countryCode) => {
    const image =
      countryData.find((it) => it.countryCode === countryCode)?.image ?? "";
    return image;
  };

  const countriesHaveComm = useMemo(() => {
    return countryList?.filter(
      (item) =>
        countryTenantList?.hasOwnProperty(item?.country_name) &&
        countryTenantList[item?.country_name]?.length > 0,
    );
  }, [countryTenantList, countryList]);

  const filteredTenants = countryTenantList[selectedCountry.country_name] || [];
  const areEveryCommPrivate =
    filteredTenants?.length > 0
      ? filteredTenants.every(
          (ele) =>
            String(ele?.type || ele?.communityType).toLowerCase() === "private",
        )
      : false;

  const areEveryCommHidden =
    filteredTenants?.length > 0
      ? filteredTenants.every(
          (ele) => String(ele?.tenantView).toLowerCase() === "hide",
        )
      : false;
  const areEveryCommNotFollowing =
    filteredTenants?.length > 0
      ? filteredTenants.every(
          (ele) =>
            String(ele?.communityFollowStatus ?? ele?.followStatus) === "0" ||
            (ele?.followStatus !== 1 && ele?.followStatus !== 2),
        )
      : false;

  const isDefaultCommunityBlocked =
    filteredTenants?.some(
      (ele) =>
        Number(ele?.communityFollowStatus ?? ele?.followStatus) === 2,
    ) ?? false;

  useEffect(() => {
    if (!signIn && areEveryCommPrivate) {
      updateAlertShow(true);
    } else if (
      signIn &&
      areEveryCommHidden &&
      areEveryCommPrivate &&
      areEveryCommNotFollowing
    ) {
      updateAlertShow(true);
    }

    if (!signIn && isDefaultCommunityBlocked === true) {
      setCountryHasDefaultCommBlocked(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    selectedCountry,
    signIn,
    areEveryCommPrivate,
    areEveryCommHidden,
    areEveryCommNotFollowing,
    isDefaultCommunityBlocked,
  ]);

  const countriesHaveNoComm = useMemo(() => {
    return countryDetails?.filter(
      (item) =>
        countryWithoutCommunities?.hasOwnProperty(item?.country_name) &&
        countryWithoutCommunities[item?.country_name]?.length === 0,
    );
  }, [countryWithoutCommunities, countryDetails]);

  return (
    <div className="searchcontainer">
      <Select
        variant="outlined"
        value={selectedCountry}
        onChange={onCountryChange}
        className="select"
        renderValue={(selected) => {
          if (Object.keys(selected).length > 0) {
            if (selected?.country_code === "GLOBAL") {
              return <PublicIcon />;
            }
            return (
              <img
                src={getCountryFlag(selected?.country_code)}
                alt={selected?.country_name?.slice(0, 1)}
                width={"26px"}
                height={"18px"}
                style={{ border: "1px solid grey", borderRadius: "2px" }}
              />
            );
          } else {
            return null;
          }
        }}
      >
        <MenuItem value={GLOBAL_SEARCH}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <PublicIcon />
            <div style={{ marginLeft: "8px" }}>Search all Countries</div>
          </div>
        </MenuItem>
         <MenuItem value="" disabled>
          <div
            style={{ backgroundColor: "black", height: "0.8px", width: "100%" }}
          />
        </MenuItem>
        {countriesHaveComm?.map((country) => (
          <MenuItem
            key={country.country_code}
            value={country}
            style={{
              fontWeight:
                selectedCountry?.country_code === country?.country_code
                  ? "bold"
                  : "normal",
              backgroundColor:
                selectedCountry?.country_code === country?.country_code
                  ? "#D0D0D0"
                  : undefined,
            }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <img
                src={getCountryFlag(country?.country_code)}
                alt={country?.country_name?.slice(0, 1)}
                width={"24px"}
                height={"18px"}
                style={{ border: "1px solid grey", borderRadius: "2px" }}
              />
              <div style={{ marginLeft: "8px" }}>{country?.country_name}</div>
            </div>
          </MenuItem>
        ))}
        <MenuItem value="" disabled>
          <div
            style={{ backgroundColor: "black", height: "0.8px", width: "100%" }}
          />
        </MenuItem>
        {countriesHaveNoComm?.map((country) => (
          <MenuItem
            key={country.country_code}
            value={country}
            style={{
              fontWeight:
                selectedCountry?.country_code === country?.country_code
                  ? "bold"
                  : "normal",
              backgroundColor:
                selectedCountry?.country_code === country?.country_code
                  ? "#D0D0D0"
                  : undefined,
            }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <img
                src={getCountryFlag(country?.country_code)}
                alt={country?.country_name?.slice(0, 1)}
                width={"24px"}
                height={"18px"}
                style={{ border: "0.5px solid lightgrey", borderRadius: "2px" }}
              />
              <div style={{ marginLeft: "8px" }}>{country?.country_name}</div>
            </div>
          </MenuItem>
        ))}
      </Select>
      <TextField
        variant="outlined"
        value={searchValue}
        placeholder="Search Community"
        onChange={handleSearch}
        className="custom-text-field search-box-choose-default-community-before-signIn"
      />
    </div>
  );
};

export default SearchBox;
